import { Controller } from '@hotwired/stimulus';

import Product from '@/modules/product';

export default class extends Controller {
  connect() {
    new Product().create();
  }
}
